// extracted by mini-css-extract-plugin
export default {"cls1":"VeloErrorCard-Title_cls1__xt31z","cls2":"VeloErrorCard-Title_cls2__0whUs VeloErrorCard-Title_cls1__xt31z"};